
import {
    toLakh,
    sumThis,
    numberWithCommas,
    toCurrency,
    sumOf,
    countOf,
    sumAndCountOf,
    showSum,
    showCount,
    showSumAndCount,
    percentChange,
    showBlank,
    changeClassTo,
    mobileNumber,
    panCardNumber,
    validEmail,
    adharNumber,
    allDirectQueries
  } from "../../commonFunctions";
  
  const createms090 = {
    label: "Create Bank Branch ",
    pageLabel: "Create Bank Branch",
    starting: true,
    url: "createms090",
    pageType: "history",
    form: [
        {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Parent Bank",
            name: "",
            description: "Enter Parent Bank" 
          },
          {
            inputType: "autocomplete",
            
            elementProps: {
              stayOpen: false,
              removeSelected: true,
              disabled: false,
              rtl: false
            },
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            options: [
              {
                label: "Normal",
                value: "Normal"
              },
              {
                label: "Normal",
                value: "Normal"
              }
            ],
            ajaxLoad: true,
            ajaxOptions: {
              query: {
                dialect: "mongodb",
                query: "getTDSflag",
                fieldType: "string",
                filters: ["pageData", "tdsflag"]
              },
              label: "display",
              value: "display"
            },
            placeHolder: "Parent Bank",
            name: "ParentBank",
            description: "Parent Bank"
          },          
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Code",
            name: "",
            description: "Enter Code"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "Code",
            name: "Code",
            description: "Enter Code"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "MICR",
            name: "",
            description: "Enter MICR"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "MICR",
            name: "MICR",
            description: "Enter MICR"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "IFSC",
            name: "",
            description: "Enter IFSC"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "IFSC",
            name: "IFSC",
            description: "Enter IFSC"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Description",
            name: "",
            description: "Enter Description"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "Description",
            name: "Description",
            description: "Enter Description"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Address",
            name: "",
            description: "Enter Address"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "Address",
            name: "Address",
            description: "Enter Address"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "PinCode",
            name: "",
            description: "Enter PinCode"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "PinCode",
            name: "PinCode",
            description: "Enter PinCode"
          },
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Area",
            name: "",
            description: "Enter Area" 
          },
          {
            inputType: "autocomplete",
            
            elementProps: {
              stayOpen: false,
              removeSelected: true,
              disabled: false,
              rtl: false
            },
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            options: [
              {
                label: "Normal",
                value: "Normal"
              },
              {
                label: "Normal",
                value: "Normal"
              }
            ],
            ajaxLoad: true,
            ajaxOptions: {
              query: {
                dialect: "mongodb",
                query: "getTDSflag",
                fieldType: "string",
                filters: ["pageData", "tdsflag"]
              },
              label: "display",
              value: "display"
            },
            placeHolder: "Area",
            name: "Area",
            description: "Area"
          }, 
          
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Phone Number",
            name: "",
            description: "Enter Phone Number"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "Phone Number",
            name: "PhoneNumber",
            description: "Enter Phone Number"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Email",
            name: "",
            description: "Enter Email"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "Email",
            name: "Email",
            description: "Enter Email"
          },
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Claring Zone",
            name: "",
            description: "Enter Claring Zone"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "Claring Zone",
            name: "ClaringZone",
            description: "Enter Claring Zone"
          },
          {
            inputType: "displaytext",
            tab: "filterop",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Weekly Off",
            name: "",
            description: "Enter Weekly Off"
          },
          {
            inputType: "select",
            
            default: "",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            options: [
              {
                label: "Monday",
                value: "Monday"
              },
              {
                label: "Tuesday",
                value: "Tuesday"
              },
              {
                label: "Wednesday",
                value: "Wednesday"
              },
              {
                label: "Thursday",
                value: "Thursday"
              },
              {
                label: "Friday",
                value: "Friday"
              },
              {
                label: "Saturday",
                value: "Saturday"
              },
              {
                label: "Sunday",
                value: "Sunday"
              },
             ],
            placeHolder: "Weekly Off",
            name: "WeeklyOff",
            description: "Enter Weekly Off"
          },      
          {
            inputType: "checkbox",
            isRequired: true,
            default: "",
            widths: {
              parent: "col-sm-6",
              children: "col-sm-12"
            },
            placeHolder: "input with checkbox",
            label: "DD Flag",
            name: "DDFlag",
            description: "DD Flag"
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "",
            widths: {
              parent: "col-sm-6",
              children: "col-sm-12"
            },
            placeHolder: "input with checkbox",
            label: "Active",
            name: "active",
            description: "Active"
          },

         
    ]
  }
  export default createms090;